import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';
import SiteOverlay from './SiteOverlay';

export default class SearchTakeover {
  constructor(el) {
    this.el = el;
    this.events = new EventHandler();
    this.siteOverlay = new SiteOverlay();

    this.input = this.el.querySelector('[data-search-input]');
    this.close = this.el.querySelector('[data-search-takeover-close]');
    this.animation = transition({ el: this.el, state: 'closed' });

    this.isOpen = false;

    this.events.register(window, 'keyup', e => this._onKeyUp(e));
    this.events.register(this.close, 'click', () => this._close());

    this.events.register(document.body, 'click', e => {
      if (!e.target.closest('[data-header-search-toggle], [data-search-takeover]')) {
        this._close();
      }
    });
  }

  _onKeyUp(e) {
    if (e.code === 'Escape') {
      this._close();
    }
  }

  open() {
    if (this.isOpen) return;
    this.isOpen = true;

    this.animation.animateTo('open')
      .then(() => {
        const { length } = this.input.value;
        this.input.setSelectionRange(length, length);
        this.input.focus();
        this.siteOverlay.open();
      });
  }

  _close() {
    if (!this.isOpen) return;

    this.animation.animateTo('closed')
      .then(() => {
        this.isOpen = false;
        this.siteOverlay.close();
      });
  }
}
